module.exports = __webpack_public_path__ + "img/pic_new_features_8.89af0969.png";